import {FC} from "react";
import { p } from "../../../interface/interface";


export const ChevronDown: FC =(props) =>{
    return(
        <>
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 448 512"
            height={10}
            width={10}
            {...props}
        >
            <path 
                d="M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
            />
        </svg>
        </>
    )
}

  export const Thick: FC = () =>{
    return(
      <svg 
        width="11" 
        height="8" 
        viewBox="0 0 11 8" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M1 4L4.375 7L10 1" 
            stroke="#F5F5F5" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
      </svg>

    )
  }

  export const EnvelopeIcon: FC<p> = (p) =>{
    
    return(
      <>
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 512 512"
            {...p}
        >
            <path 
            d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
            />
        </svg>
      </>
    )
  }

  export const LocationIcon: FC<p> = (p) => {
    return(
      <>
      <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 384 512"
          {...p}
      >
          <path 
              d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
      />
      </svg>
      </>
    )
  }

  export const PhoneIcon: FC<p> = (p) =>{
    return(
      <>
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 512 512"
            {...p}
        >
            <path 
                d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
            />
        </svg>
      </>
    )
  }

  // social 
  export const Facebook: FC<p> =(p) =>{
    return(
        <svg 
            viewBox="0 0 17 17"  
            xmlns="http://www.w3.org/2000/svg"
            {...p}
            >
            <path 
                d="M16.5654 8.45876C16.593 3.97328 12.9456 0.280789 8.46011 0.253231C3.97463 0.225673 0.28214 3.87306 0.254582 8.35855C0.229529 12.4363 3.1652 15.8185 7.03527 16.454L7.07034 10.7452L5.03149 10.7327L5.04589 8.38798L7.08475 8.40051L7.09602 6.56554C7.10855 4.52668 8.33875 3.41283 10.1737 3.4241C11.0912 3.42974 12.0074 3.63926 12.0074 3.63926L11.9949 5.67812L10.9755 5.67186C9.95606 5.66559 9.64647 6.27537 9.64271 6.88703L9.63332 8.41617L11.8761 8.42995L11.4539 10.7721L9.51697 10.7602L9.48127 16.571C13.5627 15.9844 16.5404 12.5365 16.5654 8.45876Z" 
                fill="white"
            />
        </svg>

    )
}

export const Instagram: FC<p> =(p) =>{
  return(
      <svg 
          viewBox="0 0 18 18"  
          xmlns="http://www.w3.org/2000/svg"
          {...p}
          >
          <path 
              d="M9.19209 1.65632C11.4348 1.6701 11.7407 1.67198 12.6581 1.67762C13.4737 1.68263 13.8802 1.88902 14.1854 1.99284C14.5919 2.19923 14.8971 2.30305 15.2011 2.61076C15.505 2.91847 15.707 3.22555 15.8065 3.63395C15.9065 3.9404 16.006 4.3488 16.1029 5.16497C16.0973 6.08245 16.096 6.28634 16.0816 8.63102C16.0672 10.9757 16.066 11.1796 16.0603 12.0971C16.0553 12.9126 15.8489 13.3191 15.7451 13.6243C15.5387 14.0309 15.4349 14.3361 15.1272 14.64C14.8195 14.944 14.5124 15.146 14.104 15.2454C13.7975 15.3455 13.3891 15.4449 12.573 15.5418C11.6555 15.5362 11.4516 15.5349 9.10691 15.5205C6.76223 15.5061 6.55834 15.5049 5.64086 15.4992C4.82531 15.4942 4.4188 15.2878 4.11359 15.184C3.70708 14.9776 3.40187 14.8738 3.09792 14.5661C2.79397 14.2584 2.59197 13.9513 2.49253 13.5429C2.39247 13.2365 2.29303 12.8281 2.1961 12.0119C2.20173 11.0944 2.20299 10.8905 2.21739 8.54584C2.2318 6.20116 2.23305 5.99727 2.23869 5.07979C2.2437 4.26424 2.45009 3.85773 2.55391 3.55252C2.7603 3.14601 2.86412 2.8408 3.17183 2.53685C3.47954 2.23291 3.78662 2.0309 4.19502 1.93146C4.50147 1.8314 4.90987 1.73196 5.72604 1.63503C6.64352 1.64066 6.94935 1.64254 9.19209 1.65632ZM9.20149 0.12718C6.8568 0.112775 6.65292 0.111522 5.73543 0.105885C4.81795 0.100248 4.20504 0.300376 3.69407 0.50113C3.1831 0.701884 2.67151 1.00458 2.15867 1.51116C1.64582 2.01775 1.43943 2.42426 1.12984 3.03404C0.922826 3.5425 0.817124 4.15353 0.709545 5.07039C0.703908 5.98788 0.702029 6.29371 0.68825 8.53645C0.673844 10.8811 0.672592 11.085 0.666955 12.0025C0.661318 12.92 0.861446 13.5329 1.0622 14.0439C1.26295 14.5548 1.56565 15.0664 2.07223 15.5793C2.57882 16.0921 2.98533 16.2985 3.59511 16.6081C4.10357 16.8151 4.7146 16.9208 5.63146 17.0284C6.54895 17.034 6.85477 17.0359 9.09752 17.0497C11.3403 17.0635 11.6461 17.0653 12.5636 17.071C13.4811 17.0766 14.094 16.8765 14.6049 16.6757C15.1159 16.475 15.6275 16.1723 16.1403 15.6657C16.6532 15.1591 16.8596 14.7526 17.1692 14.1428C17.3762 13.6344 17.4819 13.0233 17.5895 12.1065C17.5951 11.189 17.597 10.8832 17.6108 8.64042C17.6245 6.39767 17.6264 6.09185 17.632 5.17436C17.6377 4.25688 17.4376 3.64397 17.2368 3.133C17.036 2.62203 16.7334 2.11044 16.2268 1.5976C15.7202 1.08475 15.3137 0.87836 14.7039 0.568773C14.1954 0.361756 13.5844 0.256055 12.6675 0.148475C11.7501 0.142838 11.5462 0.141585 9.20149 0.12718Z"
              fill="white"
              />
          <path 
              d="M9.17643 4.20489C6.72981 4.18986 4.78099 6.11487 4.76596 8.5615C4.75093 11.0081 6.67594 12.9569 9.12257 12.972C11.5692 12.987 13.518 11.062 13.533 8.61536C13.5481 6.16874 11.6231 4.21992 9.17643 4.20489ZM9.13196 11.4428C7.60282 11.4334 6.28508 10.202 6.2951 8.57089C6.3045 7.04175 7.53595 5.72401 9.16704 5.73403C10.6962 5.74343 12.0139 6.97488 12.0039 8.60597C11.9945 10.1351 10.6611 11.4522 9.13196 11.4428Z" 
              fill="white"
          />
          <path 
              d="M13.6563 5.14994C14.2193 5.15339 14.6785 4.69979 14.682 4.13677C14.6854 3.57376 14.2318 3.11454 13.6688 3.11108C13.1058 3.10762 12.6466 3.56123 12.6431 4.12424C12.6397 4.68726 13.0933 5.14648 13.6563 5.14994Z" 
              fill="white"
          />
      </svg>

  )
}


export const Twitter: FC<p> =(p) =>{
  return(
      <svg  
          viewBox="0 0 17 14" 
          {...p}
          xmlns="http://www.w3.org/2000/svg"
      >
      <path 
          d="M16.5124 1.65767C15.8989 1.95974 15.2866 2.05793 14.5723 2.15549C15.2885 1.7521 15.8019 1.14357 16.0108 0.329286C15.3967 0.733299 14.6818 0.9328 13.865 1.13168C13.2571 0.516261 12.3421 0.102853 11.4246 0.0972158C9.28385 0.084063 7.64024 2.1129 8.13742 4.15488C5.38559 4.03603 2.94711 2.69574 1.22661 0.646241C0.299728 2.16975 0.797541 4.10979 2.21848 5.13798C1.70876 5.13485 1.2003 4.92784 0.691841 4.72082C0.682446 6.24996 1.79505 7.68405 3.32168 8.10121C2.81134 8.20003 2.301 8.29884 1.79192 8.19376C2.19155 9.52152 3.4086 10.5485 4.93774 10.5579C3.70879 11.4678 1.87069 11.9663 0.13891 11.7517C1.66242 12.6786 3.39169 13.3009 5.22666 13.3122C11.4452 13.3504 14.9432 8.17261 14.7687 3.38005C15.4848 2.97667 16.1002 2.36877 16.5124 1.65767Z" 
          fill="white"
      />
      </svg>
  )
}

export const LinkedIn: FC<p> = (p) =>{
  return(
    <>
      <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 448 512"
          {...p}
      >
          <path 
              d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
          />
      </svg> 
    </>
  )
}

export const ArrowRight: FC<p> = (p) => {
  return(
    <>
      <svg xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 448 512"
          {...p}
      >
          <path 
              d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
          />
      </svg>
    </>
  )
}


export const InfoBox: FC = (p) =>{
  return(
    <>
      <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          {...p}
      >
          <path 
              fillRule="evenodd" 
              clipRule="evenodd" 
              d="M4.54 2H7.92C9.33 2 10.46 3.15 10.46 4.561V7.97C10.46 9.39 9.33 10.53 7.92 10.53H4.54C3.14 10.53 2 9.39 2 7.97V4.561C2 3.15 3.14 2 4.54 2ZM4.54 13.4697H7.92C9.33 13.4697 10.46 14.6107 10.46 16.0307V19.4397C10.46 20.8497 9.33 21.9997 7.92 21.9997H4.54C3.14 21.9997 2 20.8497 2 19.4397V16.0307C2 14.6107 3.14 13.4697 4.54 13.4697ZM19.4601 2H16.0801C14.6701 2 13.5401 3.15 13.5401 4.561V7.97C13.5401 9.39 14.6701 10.53 16.0801 10.53H19.4601C20.8601 10.53 22.0001 9.39 22.0001 7.97V4.561C22.0001 3.15 20.8601 2 19.4601 2ZM16.0801 13.4697H19.4601C20.8601 13.4697 22.0001 14.6107 22.0001 16.0307V19.4397C22.0001 20.8497 20.8601 21.9997 19.4601 21.9997H16.0801C14.6701 21.9997 13.5401 20.8497 13.5401 19.4397V16.0307C13.5401 14.6107 14.6701 13.4697 16.0801 13.4697Z" 
              fill="#403C44"
          />
      </svg>

    </>
  )
}

export const StarBoxIcon:FC = (p) =>{
  return(
    <>
      <svg 
          width="26" 
          height="24" 
          viewBox="0 0 26 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          {...p}
      >
          <path 
              fillRule="evenodd" 
              clipRule="evenodd" 
              d="M23.0833 8.57765L23.948 9.44197C24.6325 10.1142 25.0048 11.0266 25.0048 11.9869C25.0168 12.9473 24.6445 13.8608 23.972 14.5439C23.964 14.5527 23.956 14.5604 23.948 14.5681C23.944 14.572 23.94 14.5759 23.936 14.5799L23.0833 15.4322C22.7471 15.7683 22.555 16.2245 22.555 16.7059V17.9411C22.555 19.9339 20.9338 21.5557 18.9403 21.5557H17.7034C17.223 21.5557 16.7667 21.7466 16.4305 22.0827L15.5658 22.947C14.8573 23.6565 13.9326 24.0034 13.0079 24.0034C12.0833 24.0034 11.1586 23.6565 10.4501 22.9602L9.57342 22.0827C9.23717 21.7466 8.78084 21.5557 8.30048 21.5557H7.06357C5.07011 21.5557 3.44892 19.9339 3.44892 17.9411V16.7059C3.44892 16.2245 3.25677 15.7683 2.92053 15.4202L2.05589 14.5679C0.650859 13.1646 0.63885 10.8705 2.04388 9.45518L2.92053 8.57765C3.25677 8.24153 3.44892 7.78536 3.44892 7.29317V6.06872C3.44892 4.07597 5.07011 2.45657 7.06357 2.45657H8.30048C8.78084 2.45657 9.23717 2.2633 9.57342 1.92717L10.4381 1.06285C11.8431 -0.352478 14.1368 -0.352477 15.5538 1.05205L16.4305 1.92717C16.7667 2.2633 17.223 2.45657 17.7034 2.45657H18.9403C20.9338 2.45657 22.555 4.07597 22.555 6.06872V7.30638C22.555 7.78536 22.7471 8.24153 23.0833 8.57765ZM9.90888 16.1404C10.1971 16.1404 10.4613 16.0324 10.6534 15.8283L16.826 9.65923C17.2343 9.25107 17.2343 8.57762 16.826 8.16947C16.4177 7.76252 15.7572 7.76252 15.3489 8.16947L9.17634 14.3398C8.76804 14.7479 8.76804 15.4202 9.17634 15.8283C9.36848 16.0324 9.63268 16.1404 9.90888 16.1404ZM15.0363 15.084C15.0363 15.6723 15.5047 16.1404 16.0931 16.1404C16.6695 16.1404 17.1378 15.6723 17.1378 15.084C17.1378 14.509 16.6695 14.0396 16.0931 14.0396C15.5047 14.0396 15.0363 14.509 15.0363 15.084ZM9.92103 7.86938C10.4975 7.86938 10.9658 8.33756 10.9658 8.91377C10.9658 9.50319 10.4975 9.97017 9.92103 9.97017C9.34461 9.97017 8.86426 9.50319 8.86426 8.91377C8.86426 8.33756 9.34461 7.86938 9.92103 7.86938Z" 
              fill="#403C44"
          />
      </svg>

    </>
  )
}

export const SingleSquareStarIcon: FC = (p) =>{
  return(
    <>
      <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          {...p}
      >
          <path 
              fillRule="evenodd" 
              clipRule="evenodd" 
              d="M6.86378 1H17.1363C20.8773 1 22.9892 3.12183 23.0002 6.8628V17.1365C23.0002 20.8763 20.8773 22.9993 17.1363 22.9993H6.86378C3.12281 22.9993 1.00098 20.8763 1.00098 17.1365V6.8628C1.00098 3.12183 3.12281 1 6.86378 1ZM12.0546 18.4454C12.5287 18.4454 12.9236 18.0934 12.9676 17.6204V6.4118C13.0116 6.07082 12.8477 5.72873 12.5507 5.54283C12.2416 5.35584 11.8676 5.35584 11.5717 5.54283C11.2736 5.72873 11.1097 6.07082 11.1416 6.4118V17.6204C11.1977 18.0934 11.5926 18.4454 12.0546 18.4454ZM17.1153 18.4454C17.5773 18.4454 17.9722 18.0934 18.0283 17.6204V14.0125C18.0602 13.6595 17.8963 13.3306 17.5982 13.1436C17.3023 12.9566 16.9283 12.9566 16.6204 13.1436C16.3223 13.3306 16.1584 13.6595 16.2024 14.0125V17.6204C16.2464 18.0934 16.6413 18.4454 17.1153 18.4454ZM7.84172 17.6205C7.79772 18.0934 7.40283 18.4454 6.92875 18.4454C6.45577 18.4454 6.05978 18.0934 6.01688 17.6205V10.0197C5.98388 9.67763 6.14778 9.33774 6.44587 9.15074C6.74176 8.96375 7.11684 8.96375 7.41383 9.15074C7.70972 9.33774 7.87582 9.67763 7.84172 10.0197V17.6205Z" 
              fill="#403C44"
          />
      </svg>
    </>
  )
}

export const Apple:FC<p> = (p) =>{
  return(
    <>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 384 512"
        {...p}
        className = {p.className}
    >

        <path 
            d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
        />
    </svg>
    </>
  )
}